import { Address } from '../../common/model/address';
import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { LeaseAgreementCategory, LeaseAgreementStatus, RentalObjectCategory } from '../../rent/model/const/enums';
import { InvoiceDeliveryMethod } from './const/enum';

export class InvoiceRecipientRecentLeaseAgreement extends ModelBase {
  category: LeaseAgreementCategory;
  leaseAgreementNumber: string;
  status: LeaseAgreementStatus;
  invoiceDeliveryMethod: InvoiceDeliveryMethod;
  costPlace: string;
  costBearer: string;
  rentalObjectOneRentalId: string;
  rentalObjectOneCategory: RentalObjectCategory;
  rentalObjectOneAddress: Address;

  _fromDate: LocalDate;
  set fromDate(value: LocalDate) {
    this._fromDate = LocalDate.fromDate(value);
  }
  get fromDate(): LocalDate {
    return this._fromDate;
  }

  _lastBillingDate: LocalDate;
  set lastBillingDate(value: LocalDate) {
    this._lastBillingDate = LocalDate.fromDate(value);
  }
  get lastBillingDate(): LocalDate {
    return this._lastBillingDate;
  }

  toString() {
    return this.leaseAgreementNumber;
  }
}
